/*global angular */
/*global window */
/*jslint node: true */

'use strict';

var carousel = angular.module('msCarousel', []);

carousel.service('msCarousel', ['$compile', '$animate', 'msExt', function ($compile, $animate, msExt) {
    var template = "<div class='msCarousel' style='bottom: 10px; right: 10px; position: relative;'>" +
        "<span ng-if='mode.edit' ng-click='msCarousel.addSlide(section)' style='border-radius: 20px; width: 20px; height: 20px; display: inline-block; margin-right: 5px;'>+</span>" +
        "<span ng-repeat='slide in section.settings.msCarousel.slides' ng-style='msCarousel.getStyle(section, $index)' ng-click='msCarousel.switchSlide(section, $index)' style='border-radius: 20px; background-color: grey; width: 20px; height: 20px; display: inline-block; margin-right: 5px;'>{{$index}}</span>" +
        "</div>";

    var animDelay = 0.5;
    var msCarousel = {
        switchSlide: function (section, index) {
            var sectionElement = msExt.getSectionElement(section);
            var children = angular.element(sectionElement).children(); // returns [container(div), slides(section).+]
            var editElement = children[0]; // .container
            var width = window.innerWidth;

            $animate.enabled(false);
            setTimeout(function () {
                $animate.enabled(true);
            }, animDelay * 1000);


            var oldIndex = section.settings.msCarousel.currentSlide;
            section.settings.msCarousel.currentSlide = index;

            var slide = section.settings.msCarousel.slides[index];
            section.groups = slide.groups;

            angular.forEach(slide.settings, function (value, key) {
                section.settings[key] = value;
            });

            editElement.style.display = 'none';
            sectionElement.style.padding = '0px';

            angular.forEach(section.settings.msCarousel.slides, function (slide, slideIndex) {
                var slideEl = children[slideIndex + 1];
                slideEl.style.backgroundColor = '';
                slideEl.style.display = 'inline-block';
                slideEl.style.position = 'absolute';
                if (slideIndex == index) slideEl.style.position = '';
                slideEl.style.transform = 'translateX(' + (-(oldIndex - slideIndex)) * width + 'px)';
                slideEl.getBoundingClientRect();
                slideEl.style.transition = 'transform ' + animDelay + 's';
                slideEl.style.transform = 'translateX(' + (-(index - slideIndex)) * width + 'px)';
            });

            editElement.style.transition = 'background ' + animDelay + 's, backgroundColor ' + animDelay + 's, background-color ' + animDelay + 's, height ' + animDelay + 's';
            sectionElement.style.transition = 'background ' + animDelay + 's, backgroundColor ' + animDelay + 's, background-color ' + animDelay + 's, height ' + animDelay + 's';
            sectionElement.style.overflow = 'hidden';

            angular.element(sectionElement).one("transitionend", function () {
                editElement.style.display = '';
                sectionElement.style.padding = '';
                angular.forEach(section.settings.msCarousel.slides, function (slide, slideIndex) {
                    var slideEl = children[slideIndex + 1];
                    slideEl.style.display = 'none';
                });
            });
        },
        addSlide: function (section) {
            var slide = section.settings.msCarousel.slides[section.settings.msCarousel.currentSlide];
            section.settings.msCarousel.slides.push({
                settings: {styles: {}, classes: {}},
                groups: angular.copy(slide.groups)
            });
        },
        getStyle: function (section, active) {
            if (active == section.settings.msCarousel.currentSlide) {
                return {backgroundColor: 'yellow'};
            } else {
                return {backgroundColor: 'grey'};
            }
        }
    };


    return {
        injectDirective: function (scope, _element) {
            var element = _element[0];
            element = element.children[0]; // children[0] = container
            var insertedElement = null;

            var section = scope.section;
            if (!section.settings) section.settings = {};
            if (!section.settings.msCarousel) section.settings.msCarousel = {};
            if (!section.settings.msCarousel.slides || section.settings.msCarousel.slides.length === 0) {
                section.settings.msCarousel.currentSlide = 0;
                section.settings.msCarousel.slides = [{
                    groups: section.groups,
                    settings: {classes: section.settings.classes, styles: section.settings.styles}
                }];
            }

            var destroyWatch = scope.$watch('section.settings.msExt.msCarousel', function (value) {
                if (!value) {
                    msCarousel.switchSlide(section, 0);
                    insertedElement.remove();
                    destroyWatch();
                }
            });


            function updateSlides() {
                if (!_element[0].classList.contains('msCarouselContainer')) {
                    _element[0].classList.add('msCarouselContainer');
                }
                for (var index = 0; index < section.settings.msCarousel.slides.length; index++) {
                    var slide = section.settings.msCarousel.slides[index];
                    if (!slide.$$_hasElement) {
                        var iso = scope.$new();
                        var linkFn = $compile('<section style="left:' + 0 + 'px;display:inline-block;width:100%;position:absolute; top:' + 0 + 'px;" ' +
                            'class="section animate-section" ng-class="section.settings.classes.join(\' \')" ng-style="addInlineStyle(section, 75)" id="{{section.settings.slug}}">' +
                            '<div class="container" render-groups></div></section>');
                        var subE = linkFn(iso);
                        iso.section = section.settings.msCarousel.slides[index];
                        angular.element(_element[0]).append(subE);
                        //slide.$$_scope = iso;
                        slide.$$_hasElement = true;
                        subE[0].style.display = 'none';
                    }
                }
            }

            if (1 == 1 || scope.publish_action) {
                updateSlides();
            }

            var linkFn = $compile(template);
            insertedElement = linkFn(scope);
            //$animate.enabled(false, insertedElement);
            angular.element(element).append(insertedElement);
        },
        config: {
            type: ['section'],
            title: 'Carousel',
            visible: function (context_type) {
                return context_type == 'section';
            },
            enable_explicit: true,
            template: '<md-switch ng-model="subject.settings.msExt.msCarousel">carousel</md-switch>' +
            '<md-switch ng-model="subject.settings.msCarousel.autoSlide">auto slide</md-switch>' // TODO: configure auto swipe, auto swipe delay!
        },
        init: function (scope, context_element) {
            scope.msCarousel = msCarousel;
        }
    };
}]);
